import Client from './client';

export default class Experiments extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments`, {
      ...options,
       method: 'POST',
    });
  }

  getByKey(organization, key, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments/${key}`, options);
  }

  putByKey(organization, key, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments/${key}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteByKey(organization, key, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments/${key}`, {
      ...options,
       method: 'DELETE',
    });
  }

  putSessionAndQueryByKey(organization, key, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments/${key}/session/query`, {
      ...options,
       method: 'PUT',
    });
  }

  putByKeyAndStatus(organization, key, status, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/experiments/${key}/${status}`, {
      ...options,
       method: 'PUT',
    });
  }

}
